import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import App from './App';
import { msalInstance } from './authConfig';
import './index.css';

// Initialize MSAL instance before rendering
msalInstance.initialize().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}).catch((error) => {
  console.error('MSAL initialization failed:', error);
  document.getElementById('root').innerHTML = '<p>Failed to initialize authentication. Check console for details.</p>';
});
